import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useLayoutEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function Service3() {
  const { t } = useTranslation();
  const containerRef = useRef(null);
  const textRef = useRef(null);
  const imageRef = useRef(null);

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      // Animation pour le texte (arrive de la gauche)
      gsap.fromTo(
        textRef.current,
        { x: -100, opacity: 0 },
        {
          x: 0,
          opacity: 1,
          duration: 1,
          ease: "power2.out",
          scrollTrigger: {
            trigger: containerRef.current,
            start: "top 80%",
            toggleActions: "play none none reverse",
          },
        }
      );

      // Animation pour l'image (arrive de la droite avec délai)
      gsap.fromTo(
        imageRef.current,
        { x: 100, opacity: 0 },
        {
          x: 0,
          opacity: 1,
          duration: 1,
          delay: 0.3,
          ease: "power2.out",
          scrollTrigger: {
            trigger: containerRef.current,
            start: "top 80%",
            toggleActions: "play none none reverse",
          },
        }
      );
    }, containerRef);

    return () => ctx.revert();
  }, []);

  return (
    <div className="Accueil-Service Service3" ref={containerRef}>
      <div className="TopSection">
        <p>[{t("services.label")}]</p>
        <h2>{t("service3.title")}</h2>
        <div className="Spacer"></div>
      </div>
      <article className="BottomSection">
        <div className="BottomSection-Text" ref={textRef}>
          <p>{t("service3.text")}</p>
          <ul>
            <span>{t("service3.tag1")}</span>
            <span>{t("service3.tag2")}</span>
          </ul>
          <Link to="/services" rel="noreferrer" className="websiteBtn thin">
            {t("services.more")}
          </Link>
        </div>
        <img
          ref={imageRef}
          src={require("../../assets/img/Accueil/Service3.png")}
          alt=""
        />
      </article>
    </div>
  );
}
